export const removeHTMLNode = $el => {
  if ($el.remove != null) {
    return $el.remove();
  } else {
    return $el.removeNode(true);
  }
};
